import { Repair } from '../types';

export const getAddContractorsBlocked = (repair?: Repair) =>
  !!(repair && Number(repair?.poTotal) >= 350.01 && !repair?.poReleased);
